module.exports = __webpack_public_path__ + "img/Glasses.9acac222.png";